<template>
  <section class="menus-detail-container">
    <base-header
      v-bind="headers"
      @handleBack="handleClickBack"
    />
    <base-form
      ref="form"
      v-bind="form"
    >
      <template #attachment="scope">
        <div class="apis-list-wrap">
          <span>{{scope.form[scope.item.prop] && scope.form[scope.item.prop].fileId ? scope.form[scope.item.prop].fileName : '暂无'}}&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <el-button v-if="scope.form[scope.item.prop] && scope.form[scope.item.prop].fileId" type="primary" size="small" width="82px" @click="handleDownload(scope.form[scope.item.prop])">
            点击下载
          </el-button>
        </div>
      </template>
      <template #attachment2="scope">
        <div class="apis-list-wrap">
          <span>{{scope.form[scope.item.prop] && scope.form[scope.item.prop].fileId ? scope.form[scope.item.prop].fileName : '暂无'}}&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <el-button v-if="scope.form[scope.item.prop] && scope.form[scope.item.prop].fileId" type="primary" size="small" width="82px" @click="handleDownload(scope.form[scope.item.prop])">
            点击下载
          </el-button>
        </div>
      </template>
    </base-form>
  </section>
</template>
<script>
import baseHeader from '@/components/mixins/baseHeader'
import baseForm from '@/components/mixins/baseForm'
import formDialog from '@/components/mixins/formDialog'

export default {
  name: 'extcontentDetail',
  mixins: [baseHeader, baseForm, formDialog],
  data () {
    return {
      headers: {
        buttons: [
          {
            type: 'Back',
            text: '返回',
            icon: 'fanhui'
          }
        ],
        title: '',
        showAlertIcon: false,
        content: '稿件初审一般需要1-3个月时间。一经录用，作者即将注册章程所载著作财产权让予本编委会。'
      },
      form: {
        api: 'fetchUserCenterContentDetail',
        params: {
          id: ''
        },
        form: {
          id: '',
          title: '',
          attachment: {},
          innovationContent: '',
          remark: '',
          status: ''
        },
        formItems: [
          {
            prop: 'title',
            label: '稿件名称：',
            type: 'text'
          },
          {
            prop: 'attachment',
            label: '稿件附件：',
            type: 'slot'
          },
          {
            prop: 'innovationContent',
            label: '文章创新点：',
            type: 'text'
          },
          {
            prop: 'remark',
            label: '备注说明：',
            type: 'text'
          },
          {
            prop: 'status',
            label: '状态：',
            type: 'text',
            options: [
              {
                label: '草稿',
                value: 'DRAFT'
              },
              {
                label: '待审核',
                value: 'UNCHECK'
              },
              {
                label: '审核中',
                value: 'CHECKING'
              },
              {
                label: '已撤稿',
                value: 'CANCEL'
              },
              {
                label: '已返修',
                value: 'REFUND'
              },
              {
                label: '已录用',
                value: 'SUCCESS'
              },
              {
                label: '退稿',
                value: 'CANCELED'
              },
              {
                label: '退稿',
                value: 'SYSTEM_CANCELED'
              },
              {
                label: '申请撤稿',
                value: 'CHECK_CANCEL'
              },
              {
                label: '审核中',
                value: 'CHECKING_PROFESSOR'
              }
            ]
          },
          {
            prop: 'remark2',
            label: '备注说明：',
            type: 'text'
          },
          {
            prop: 'attachment2',
            label: '备注附件：',
            type: 'slot'
          }
        ],
        rules: {},
        submitBtns: []
      }
    }
  },
  inject: ['removeTab'],
  methods: {
    fetchFormCallBack (res) {
      if (res.code === 200) {
        res.data.hidden = !res.data.hidden
        this.$set(this.form, 'form', {
          id: res.data.id,
          title: res.data.title,
          innovationContent: res.data.innovationContent,
          remark: res.data.remark,
          status: res.data.status,
          remark2: res.data.status === 'REFUND' || res.data.status === 'CANCELED' ? res.data.details.length > 0 ? res.data.details[res.data.details.length - 1].remark : '暂无' : '暂无',
          attachment: {
            fileName: res.data.attachmentName,
            fileId: res.data.attachment
          },
          attachment2: {
            fileName: res.data.status === 'REFUND' || res.data.status === 'CANCELED' ? res.data.details.length > 0 ? res.data.details[res.data.details.length - 1].attachmentName : '暂无' : '暂无',
            fileId: res.data.status === 'REFUND' || res.data.status === 'CANCELED' ? res.data.details.length > 0 ? res.data.details[res.data.details.length - 1].attachment : '' : ''
          }
        })
      }
    },
    handleDownload (data, btn) {
      console.log(data)
      // 下载
      var ids = [data.fileId]
      this.$request.resourceSpaceDatasDownload({ ids: ids }).then(res => {
        this.$exportClick(res, data.fileName)
      })
    },
    handleClickBack () {
      this.removeTab(this.$route.fullPath)
      this.$router.replace({ name: 'userCenterContentIndex' })
    }
  },
  mounted () {
    const { id } = this.$route.query
    this.form.params.id = id
    this.fetchFormApi()
  },
  activated () {
    const { id } = this.$route.query
    if (id) {
      this.form.params.id = id
      this.fetchFormApi()
    }
  }
}
</script>
<style lang="scss" scoped>
.menus-detail-container{
  .apis-list{
    color: #666666;
    display: flex;
    flex-direction: column;
    width: 414px;
    .api-item{
      font-size: 14px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      line-height: 22px;
      padding: 10px 30px 10px 10px;
      border: 1px solid #e8e8e8;
      border-radius: 4px;
      margin-top: 10px;
      position: relative;
      span {
        word-break: break-all;
      }
      span:last-of-type{
        flex: 1;
      }
      i{
        cursor: pointer;
        position: absolute;
        right: 10px;
      }
    }
  }
  .status-list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    border: solid 1px #e5e5e5;
    .status-item {
      display: flex;
      align-items: center;
      padding: 20px;
      box-sizing: border-box;
      span {
        display: block;
        text-align: left;
      }
      .text {
        line-height: 26px;
        color:#5f5d5d;
      }
      .title {
        color: #000;
      }
    }
    .status-icon {
      margin-left: 20px;
    }
  }
}
</style>
